module.exports = __webpack_public_path__ + "classic.f80e6c5.png";